import { default_dashboard } from '@core/breadcrumbs';

const module = default_dashboard.extend('phone_number').add('phone-number.breadcrumb.title', {
  name: 'phone-number.index'
});

const numbers_breadcrumbs = module
  .extend('phone-number.number.index')
  .add('phone-number.breadcrumb.number.index', {
    name: `phone-number.number.index`
  });

const buy_breadcrumbs = module
  .extend('phone-number.number.buy')
  .add('phone-number.breadcrumb.number.buy', {
    name: `phone-number.number.buy`
  });

const stats_breadcrumbs = module
  .extend('phone-number.stats.type')
  .add('shared.breadcrumb.stats.title', {
    name: `phone-number.stats.index`
  });

const phone_number_breadcrumbs = [numbers_breadcrumbs, buy_breadcrumbs, stats_breadcrumbs];

export { phone_number_breadcrumbs };
